// @ts-nocheck

import React from 'react';

import TripListByType from '../components/TripListByType';
import { tripTypeEnum } from '../../../lib/enum';





const IncomeTripList = ({ location = {} }) =>
<TripListByType location={location} tripType={tripTypeEnum.income} />;


export default IncomeTripList;